import classNames from 'classnames'
import BaseTooltip from 'components/BaseTooltip'
import DeleteIcon from 'mdi-react/DeleteIcon'
import React, { useCallback } from 'react'
import { useMutation } from 'react-query'
import { AsyncIconButton } from 'scenes/Dashboard/components-next/Button'
import { makeStyles } from 'tss-react/mui'

import { Theme } from '@mui/material'

import { useUserListViewStore } from '../UserListViewStore'
import { User } from '../../../../../../../entities-next/user'

type DeleteUserButtonProps = {
  className: string
  user: User
}

export function DeleteUserButton({ className, user }: DeleteUserButtonProps) {
  const { classes } = useStyles()
  const {
    actions: { deleteUser },
  } = useUserListViewStore()
  const { mutateAsync: handleCorporateDelete, status } = useMutation(deleteUser)
  const isLoading = status === 'loading'
  const handleClick = useCallback(() => handleCorporateDelete(user), [handleCorporateDelete, user])

  return (
    <BaseTooltip title="Delete user" bottom>
      <AsyncIconButton
        className={classNames(className, classes.iconContainer)}
        loading={isLoading}
        onClick={handleClick}
      >
        <DeleteIcon className={classes.fillParent} />
      </AsyncIconButton>
    </BaseTooltip>
  )
}

const useStyles = makeStyles()(({ spacing }: Theme) => ({
  iconContainer: {
    width: spacing(4),
    height: spacing(4),
  },
  fillParent: {
    width: '100%',
    height: '100%',
  },
}))
